/**
 * Generates operation label for supply/borrow actions based on input amounts.
 * @param inputCollateralAmount - Collateral amount being supplied
 * @param inputLoanAmount - Loan amount being borrowed
 * @returns Human-readable operation label
 */
export const getSupplyBorrowOperationLabel = (
  inputCollateralAmount: bigint,
  inputLoanAmount: bigint
): string => {
  if (inputCollateralAmount && inputLoanAmount) return 'supply collateral & borrow'
  if (inputCollateralAmount) return 'supply collateral'
  return 'borrow'
}

/**
 * Generates operation label for repay/withdraw actions based on input amounts.
 * @param inputCollateralAmount - Collateral amount being withdrawn
 * @param inputLoanAmount - Loan amount being repaid
 * @returns Human-readable operation label
 */
export const getRepayWithdrawOperationLabel = (
  inputCollateralAmount: bigint,
  inputLoanAmount: bigint
): string => {
  if (inputCollateralAmount && inputLoanAmount) return 'repay & withdraw collateral'
  if (inputCollateralAmount) return 'withdraw collateral'
  return 'repay'
}
